import { createFileRoute } from "@tanstack/react-router";
import { HomePage } from "../../../features/home/pages/home-page";
import { homeQueryOptions } from "../../../features/home/api/home-query-options";
import { activitiesApi } from "../../../features/activities/api/activities.api";
import { activityKeys } from "../../../features/activities/constants/query-keys";
import { womenTripsQueryOptions } from "../../../features/women/api/women-query";

const HOME_CATEGORY_RAIL_SLUGS = ["quad", "horse", "buggy"] as const;

export async function loadHomeCategoryRails({
  params,
  context,
}: {
  params: { lang: string };
  context: { queryClient: import("@tanstack/react-query").QueryClient };
}) {
  const { queryClient } = context;
  const lang = params.lang;
  await Promise.all([
    queryClient.prefetchQuery(homeQueryOptions(lang)).catch((reason) => {
      console.error("[home loader] prefetch home failed:", reason);
    }),
    // The women-only banner and chip, so they are in the server HTML. A
    // failure only leaves them out; prefetchQuery never throws.
    queryClient.prefetchQuery(womenTripsQueryOptions(lang)),
    ...HOME_CATEGORY_RAIL_SLUGS.map((slug) => {
      const filters = { category: slug, page_size: "10", lang } as const;
      return queryClient
        .prefetchQuery({
          queryKey: activityKeys.list(filters),
          queryFn: () => activitiesApi.list(filters),
          staleTime: 60_000,
        })
        .catch((reason) => {
          console.error(`[home loader] prefetch ${slug} rail failed:`, reason);
        });
    }),
  ]);
  return null;
}

export const Route = createFileRoute("/$lang/_layout/")({
  loader: loadHomeCategoryRails,
  component: HomePage,
});
